import { type ReactElement } from 'react'

import { Section } from '@orus.eu/pharaoh-next/components/ui/section'
import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'

import { legalAssistanceRequests } from './legal-assistance-requests.constants.ts'

/** Pending placeholder for the requests section — same Section frame and grid as the real one. */
export function LegalAssistanceRequestsSectionSkeleton(): ReactElement {
  return (
    <Section.Root>
      <Section.Header>
        <Skeleton variant="text" width={220} height={24} />
      </Section.Header>
      <Section.Body>
        <div
          className="
            grid gap-stack
            md:grid-cols-2
          "
        >
          {legalAssistanceRequests.map((request) => (
            <Skeleton key={request.directAccess} variant="block" height={280} />
          ))}
        </div>
      </Section.Body>
    </Section.Root>
  )
}
